import React from "react";

function Plot_Graphics() {
  return (
    <div>
      <h1>Plot_Graphics Component</h1>
      <p>This is the Plot Graphics tutorial page content.</p>
    </div>
  );
}

export default Plot_Graphics;
